import invariant from 'invariant';

import type {
  CmsApiCmsPageLink,
  CmsApiUrlLink,
} from '#/modules/cms/api/types/CmsApiLink';
import { CmsApiLinkType } from '#/modules/cms/api/types/CmsApiLink';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

import type { CmsButtonRender } from './types/CmsButtonRender';

type Props = {
  buttonData: CmsApiUrlLink | CmsApiCmsPageLink;
  eventProperties: Record<string, unknown>;
  render: CmsButtonRender;
};

export function CmsLinkButton({ eventProperties, buttonData, render }: Props) {
  const { url } = buttonData.data;
  invariant(url, 'Button url is not defined');

  const onClick = () => {
    trackClicked('CMS Block', {
      url,
      ...eventProperties,
    });
  };

  const title =
    buttonData.type === CmsApiLinkType.CMS_PAGE
      ? buttonData.data.pageTitle
      : undefined;

  return render({
    data: { type: 'link', href: url, onClick },
    children: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {buttonData.text}
      </div>
    ),
    title,
    qaId: 'cms-button-link',
  });
}
